module.exports = __webpack_public_path__ + "static/img/eml.74de243d.png";